import { positionSprinkles } from './position.css';

/**
 * CSS position property and related props
 */
export const position = (props: Parameters<typeof positionSprinkles>[0]) => {
	return positionSprinkles(props);
};
